













import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';
import CashflowTable from '@/components/CashflowTable.vue';
import ProfitLossTable from '@/components/ProfitLossTable.vue';
import BalanceTable from '@/components/BalanceTable.vue';

@Component({components: {
    BalanceTable,
    ProfitLossTable,
    CashflowTable}})
export default class Chart extends Slide {
  get title() {
    switch (this.section.SubType) {
      case 'profitlossYears': return 'Flerårstabell';
      case 'balanceYears': return 'Flerårstabell';
      case 'cashflowYears': return 'Flerårstabell';
    }
    return '';
  }
}
